import React from 'react'
import philippeDeRyckImg from '../../images/speakers/Philippe-DeRyck.jpg'

const PhilippeDeRyckWorkshop = () => (
<section id="speaker" className="parallax-section">
	<div className="container">
    <br /><br /><br /><br /><br /><br />
		<div className="row">
            <div className="col-md-12 col-sm-12 wow fadeInUp" data-wow-delay="0.1s">
                <div className="team-wrapper">
					<h3>Workshop: A builder's guide to API security by Philippe De Ryck</h3>
                    <br />
                    <h4>Date: Thursday, 26 March</h4>
                    <h4>The Place: Wantsome, The Friendly IT Academy, Centris Building, Colonel Langa 17, Iași</h4>
                    <br />
                    <div className="row">
                        <div className="col-md-4">
                            <img src={philippeDeRyckImg} className="img-responsive" alt="Philippe De Ryck" />
                            <ul className="social-icon">
                                <li><a href="https://www.linkedin.com/in/philippederyck/" target="_blank" className="fa fa-linkedin wow fadeIn" data-wow-delay="0.3s"></a></li>
                                <li><a href="https://twitter.com/philippederyck" target="_blank" className="fa fa-twitter wow fadeIn" data-wow-delay="0.6s"></a></li>
                            </ul>
                        </div>
                        <div className="col-md-7">
                        <p>
                        Philippe De Ryck helps developers protect companies through better web security. As the founder of Pragmatic Web Security, he travels the world to train developers on web security and security engineering. <br />
                        His Ph.D. in web security from KU Leuven lies at the basis of his exceptional knowledge of the security landscape. Google recognizes Philippe as a Google Developer Expert for his work on security in Angular applications.
                        </p>
                        </div>
                    </div>
                    <div className="row">
                        <h4>Schedule</h4>
                        <p>
                            <br />
                            08:30 - 09:00 - Registration<br />
                            09:00 - 13:00 -  Workshop<br />
                            13:00 - 14:00 - Lunch<br />
                            14:00 - 18:00 - Workshop<br />
                            <br />
                        </p>
                        <h4>About the workshop</h4>
                        <p>
                        Most modern applications consist of a frontend web or mobile application, backed by several API-based services. This paradigm shift from server-side page generation causes a significant impact on various security aspects. To build secure applications, developers need to be aware of these security changes, along with current best practices. 
                        <br />
                        This one-day workshop offers a unique in-depth perspective on modern API security.
                        <ul className="list-group list-group-flush row">
                            <li className="list-group-item list-group-item-coloured col-xs-12">API authentication</li>
                            <li className="list-group-item list-group-item-coloured col-xs-12">Managing "sessions"</li>
                            <li className="list-group-item list-group-item-coloured col-xs-12">Securely handling JSON Web Tokens</li>
                            <li className="list-group-item list-group-item-coloured col-xs-12">Understanding and securing Cross-Origin Resource Sharing (CORS)</li>
                            <li className="list-group-item list-group-item-coloured col-xs-12">Custom-built offensive and defensive lab assignments</li>
                        </ul>                    
                        </p>
                        <br />
                        <h4>Prerequisites</h4>
                        <p> 
                            Experience with developing web-facing APIs.<br />
                            A laptop with a modern browser (e.g., Chrome, Firefox) installed.
                        </p>
                        <h4>Target audience</h4>
                        <p> 
                            Anyone who is concerned about building secure APIs.
                        </p>
                    </div>                                        
                    <div className="content row" id="tickets">
                        <div className="plans">
                            <div className="plan">
                                <h2 className="plan-title">Workshop <br />Early bird</h2>
                                <ul className="plan-features">
                                    <li><strong>9 December - 19 January</strong></li>
                                </ul>
                                <p className="plan-price">€350</p>
                                <ul className="plan-features">
                                    <li>VAT NOT included</li>
                                </ul>
                                <a className="btn btn-info btn-tickets disabled" href="#" target="_blank"> Sold out </a>
                            </div>
                            <div className="plan plan-tall">
                                <h2 className="plan-title">Workshop <br />Normal</h2>
                                <ul className="plan-features">
                                    <li><strong>20 January - 8 March</strong></li>
                                </ul>
                                <p className="plan-price">€400</p>
                                <ul className="plan-features">
                                    <li>VAT NOT included</li>
                                </ul>
                                <a className="btn btn-info btn-tickets" href="https://forms.gle/QUouQAUX5LvEi9r89" target="_blank"> Register </a>
                            </div>
                            <div className="plan">
                                <h2 className="plan-title">Workshop <br />Late bird</h2>
                                <ul className="plan-features">
                                    <li><strong>8 March - 25 March</strong></li>
                                </ul>
                                <p className="plan-price">€450</p>
                                <ul className="plan-features">
                                    <li>VAT NOT included</li>
                                </ul>
                                <a className="btn btn-info btn-tickets disabled" href="#" target="_blank"> Not available </a>
                            </div>
                        </div>	
                    </div>
				</div>
			</div>
        </div>
    </div>
</section>
)

export default PhilippeDeRyckWorkshop


// WEBPACK FOOTER //
// ./src/pages/workshops/api-security.js